var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-textarea',{attrs:{"filled":"","label":"Client Public Key","rules":[
      (v) => !!v || 'Public is required',
      (v) => /^[0-9a-fA-F]+$/.test(v) || 'Hexadecimal format is expected',
    ],"hint":"SubjectPublicKeyInfo der encoded in Hexadecimal","spellcheck":"false"},on:{"input":function($event){return _vm.$emit('input', _vm.rpk)}},model:{value:(_vm.rpk.key),callback:function ($$v) {_vm.$set(_vm.rpk, "key", $$v)},expression:"rpk.key"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }